import {find, findFirst, next} from "@21torr/dune/dom/traverse.js";
import {toggleClass} from "@21torr/dune/dom/attrs.js";
import {on} from "@21torr/dune/dom/events.js";
import {isEmpty, isNotEmpty} from "../util/type-utils.js";
import {attachTouchClickEventListener} from "../util/event-utils.js";
import jQuery from "jquery";
import {scrollIntoView} from "../util/scroll-utils.js";


const FORM_INIT_CLASS = 'form-init';
const FORM_INPUT_PASSWORD_CLASS = 'input-password';
const FORM_SECTION_ERROR_CLASS = 'has-error';

/**
 *
 * @param {HTMLInputElement} input
 * @returns boolean
 */
function isFilled(input) {
    return input.value !== ""
        || document.activeElement === input
        || input.getAttribute("placeholder");
}

/**
 * Animate form label if empty/filled
 *
 * @param {HTMLInputElement} input
 */
export function initFormInput(input) {

    if (input.classList.contains(FORM_INIT_CLASS)) {
        return;
    }

    const updateIsOpen = () => {

        // Primefaces datepicker
        if (isNotEmpty(input.parentElement) && input.parentElement.classList.contains("p-datepicker")) {
            toggleClass(input.parentElement, "is-filled", isFilled(input));
        }

        // primefaces wrapper elements
        if (isNotEmpty(input.parentElement) && input.parentElement.classList.contains("ui-inputwrapper")) {
            toggleClass(input.parentElement, "is-filled", isFilled(input));
        }

        toggleClass(input, "is-filled", isFilled(input));
    }

    on(input, ["input", "focus", "blur"], updateIsOpen);

    updateIsOpen();


    if (input.classList.contains(FORM_INPUT_PASSWORD_CLASS)) {
        initFormPassword(input);
    }


    input.classList.add(FORM_INIT_CLASS);
}

/**
 * Adds listeners for hiding/showing a password mask
 *
 * @param {HTMLInputElement} input
 */
function initFormPassword(input) {
    let passwordShowIcon = next(input, '.password-visible-icon');

    if (isEmpty(passwordShowIcon)) {
        return;
    }
    passwordShowIcon = passwordShowIcon[0];

    const togglePasswordMask = () => {
        let showPassword = !input.classList.contains('password-visible')

        toggleClass(input, "password-visible", showPassword);

        input.type = showPassword ? 'text' : 'password';
    };

    attachTouchClickEventListener(passwordShowIcon, togglePasswordMask);
}

/**
 *
 * @param {HTMLElement} container
 */
export function initFormAccordion(container) {
    find('.accordion-wrapper', container).forEach(
        accordion => {
            const button = findFirst(".accordion", accordion);
            let isOpen = accordion.classList.contains("is-open");

            if (!button) {
                return;
            }

            on(button, "click", () => {
                isOpen = !isOpen;
                toggleClass(accordion, "is-open", isOpen);
            });
        }
    );
}

export function initDatePicker(container) {

    const alternateInputFormats = [{
        format: 'dd.mm.yy',
        length: 10
    }, {
        format: 'ddmmyy',
        length: 8
    }, {
        format: 'ddmmy',
        length: 6
    }];

    const $ = window.$;

    const options = {
        dateFormat: 'dd.mm.yy',
        changeMonth: true,
        changeYear: true,
        onClose: function (dateText, inst) {
            // Get current datepicker's options
            let settings = $(this).datepicker("option", "settings");
            // Parse input string

            let curDate;
            for (let format of alternateInputFormats) {

                if (isEmpty(dateText) || dateText.toString().length !== format.length) {
                    continue;
                }

                try {
                    curDate = $.datepicker.parseDate(format.format, dateText, settings);
                } catch (e) {
                    //nop
                }
            }
            // If it is indeed a date
            if (typeof curDate !== "undefined") {
                // Update input field with formatted date
                $(this).datepicker("setDate", curDate);
            }
        }
    };

    jQuery(container).datepicker(options)

}

/**
 * Tries to find the first form-section container that is invalid (has the has-error class)
 * If found, the viewport will be scrolled so that element is visible
 * Otherwise, does nothing
 *
 * @param {HTMLElement} formContainer
 */
export function scrollToFirstFormError(formContainer, scrollOptions) {

    scrollOptions = scrollOptions || {tolerance: 500};

    if (isEmpty(formContainer)) {
        return;
    }

    const firstErrorElement = findFirst(`.${FORM_SECTION_ERROR_CLASS}`, formContainer);

    if (isEmpty(firstErrorElement)) {
        return;
    }

    scrollIntoView(firstErrorElement, scrollOptions);


}